import {ComputedHeldPosition} from '../../../components/dex/dex-streaming/types/computed/computed-held-position';
import {
    createColumnsDict,
    Table,
    TABLE_COLUMN_SIZING_FN,
    TableColumn,
    TableColumnConfig,
    TableColumnsDefMap,
    TableColumnsSizingStep
} from '../../../components/tables/table';

export interface DexDisplayLpDetailsComposItem {
    raw: ComputedHeldPosition;
    id: number;
    symbol: string;
    unrealisedPnlPercent: number; // TODO
    counterparty: string;
}

export type DexLpDetailsTable = Table<DexLpDetailsTableColumnKey, DexDisplayLpDetailsComposItem>;

export enum DexLpDetailsTableColumnKey {
    ID                     = 'ID',
    SYMBOL                 = 'SYMBOL',
    BALANCE                = 'BALANCE',
    ENTRY_VALUE            = 'ENTRY_VALUE',
    RATE                   = 'RATE',
    PORTFOLIO_VALUE        = 'PORTFOLIO_VALUE',
    UNREALISED_PNL         = 'UNREALISED_PNL',
    UNREALISED_PNL_PERCENT = 'UNREALISED_PNL_PERCENT',
    COUNTERPARTY           = 'COUNTERPARTY'
}

export interface DexLpDetailsTableColumn extends TableColumn {
    key: DexLpDetailsTableColumnKey;
}

export interface DexLpDetailsTableColumnConfig extends TableColumnConfig {
    key: DexLpDetailsTableColumnKey;
}

export enum DexLpDetailsTableColumnSizeGroup {
    ID,
    SYMBOL,
    BALANCE,
    ENTRY_VALUE,
    RATE,
    PORTFOLIO_VALUE,
    UNREALISED_PNL,
    UNREALISED_PNL_PERCENT,
    COUNTERPARTY
}

export const DEX_LP_TABLE_COLUMN_SIZE_GROUPS = [
    DexLpDetailsTableColumnSizeGroup.ID,
    DexLpDetailsTableColumnSizeGroup.SYMBOL,
    DexLpDetailsTableColumnSizeGroup.BALANCE,
    DexLpDetailsTableColumnSizeGroup.ENTRY_VALUE,
    DexLpDetailsTableColumnSizeGroup.RATE,
    DexLpDetailsTableColumnSizeGroup.PORTFOLIO_VALUE,
    DexLpDetailsTableColumnSizeGroup.UNREALISED_PNL,
    DexLpDetailsTableColumnSizeGroup.UNREALISED_PNL_PERCENT,
    DexLpDetailsTableColumnSizeGroup.COUNTERPARTY
];

export const DEX_LP_TABLE_COLUMNS_DEF: DexLpDetailsTableColumn[] = [
    {
        label:       'ID',
        key:         DexLpDetailsTableColumnKey.ID,
        width:       '8%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.ID,
        isHidden:    true
    },
    {
        label:       'Symbol',
        key:         DexLpDetailsTableColumnKey.SYMBOL,
        width:       '32%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.SYMBOL
    },
    {
        label:       'Balance',
        key:         DexLpDetailsTableColumnKey.BALANCE,
        width:       '13%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.BALANCE
    },
    {
        label:       'Entry Value',
        key:         DexLpDetailsTableColumnKey.ENTRY_VALUE,
        width:       '13%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.ENTRY_VALUE
    },
    {
        label:       'Rate',
        key:         DexLpDetailsTableColumnKey.RATE,
        width:       '10%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.RATE
    },
    {
        label:       'Portfolio Value',
        key:         DexLpDetailsTableColumnKey.PORTFOLIO_VALUE,
        width:       '8%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.PORTFOLIO_VALUE
    },
    {
        label:       'Unrealised Pnl',
        key:         DexLpDetailsTableColumnKey.UNREALISED_PNL,
        width:       '8%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.UNREALISED_PNL
    },
    {
        label:       '',
        key:         DexLpDetailsTableColumnKey.UNREALISED_PNL_PERCENT,
        width:       '8%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.UNREALISED_PNL_PERCENT
    },
    {
        label:       'Counterparty',
        key:         DexLpDetailsTableColumnKey.COUNTERPARTY,
        width:       '10%',
        sizeGroupId: DexLpDetailsTableColumnSizeGroup.COUNTERPARTY,
        isHidden:    true
    }
];

export const DEX_LP_DETAILS_TABLE_COLUMNS_DICT: TableColumnsDefMap<DexLpDetailsTableColumnKey, DexLpDetailsTableColumn> =
                 createColumnsDict(DEX_LP_TABLE_COLUMNS_DEF);

export const DEX_LP_DETAILS_TABLE_COLUMNS_SIZING:
                 Array<TableColumnsSizingStep<DexLpDetailsTableColumnSizeGroup>> =
                 [
                     ...DEX_LP_TABLE_COLUMN_SIZE_GROUPS
                         .map<TableColumnsSizingStep<DexLpDetailsTableColumnSizeGroup>>(sizeGroupId => ({
                             sizeGroupId,
                             getGroupSize: TABLE_COLUMN_SIZING_FN.fixedWidth(50)
                         })),
                     ...DEX_LP_TABLE_COLUMN_SIZE_GROUPS
                         .map<TableColumnsSizingStep<DexLpDetailsTableColumnSizeGroup>>(sizeGroupId => ({
                             sizeGroupId,
                             getGroupSize: TABLE_COLUMN_SIZING_FN.lazyFitContent(8)
                         })),
                     {
                         sizeGroupId:  DexLpDetailsTableColumnSizeGroup.SYMBOL,
                         getGroupSize: TABLE_COLUMN_SIZING_FN.stretch()
                     }
                 ];
